import {AesRsaEncryptedData} from "@qid/crypto";
import {DocumentData} from "../models/document-data.model";

export class CreateSharedIdDto {

    parentDocumentId: string;

  recipientAccount_id: string;

    aesRsaEncryptedData: AesRsaEncryptedData;

    documentData: DocumentData;

    constructor() {
    }


}
